import { Modal } from '../modal/Modal';
import styled from 'styled-components';
import { Button } from '../Button';
import { COLORS } from '../../utils/constants';

export interface ModalSubmitEntityProps {
  entity: any;
  show?: boolean;
  onClose: () => void;
  onSubmit: () => void;
  hasProduct: boolean;
  onAddProduct: () => void;
}

export const ModalSubmitEntity = ({ entity, show, onClose, onSubmit, hasProduct, onAddProduct }: ModalSubmitEntityProps) => {
  return (
    <>
      {show && (
        <Modal
          onClose={onClose}
          size={{ height: undefined, width: '40%' }}
          show={show}
          title={`Terminer et soumettre votre entité : <b>${entity?.name}</b>`}>
          <BasicModalContainer>
            {hasProduct ? (
              <StyledSpan>
                {' '}
                <b>Félicitations ! Vous avez rempli tous les questionnaires à 100%.</b>
                <br />
                <br />
                Si vous n’avez pas d’autres <b>produits à ajouter</b> (site internet / app en ligne / landing page / blog…) nous vous invitons à{' '}
                <b>soumettre</b> l’entité afin que nous puissions <b>valider vos réponses</b> et avancer dans votre mise en <b>conformité RGPD.</b>
              </StyledSpan>
            ) : (
              <StyledSpan>
                {' '}
                <b>Félicitations ! Vous avez rempli tous les questionnaires à 100%.</b>
                <br />
                <br />
                Nous remarquons que vous n’avez pas de <b>produits</b> (site internet / app en ligne / landing page / blog…), si c’est bien le cas
                vous pouvez <b>soumettre votre entité</b> afin que nous puissions <b>valider vos réponses</b> et avancer dans votre mise en{' '}
                <b>conformité RGPD.</b>
              </StyledSpan>
            )}

            <ButtonContainer>
              <Button onClick={onSubmit} label={'Soumettre'} />
              {!hasProduct && <Button onClick={onAddProduct} label={'Ajouter un service'} />}
            </ButtonContainer>
          </BasicModalContainer>
        </Modal>
      )}
    </>
  );
};

const BasicModalContainer = styled.div`
  display: flex;
  flex-direction: column;
  column-gap: 20px;
  align-items: center;
  row-gap: 26px;

  p {
    font-size: 1.3em;
    font-weight: 400;
    font-family: 'Roboto', serif;
    line-height: 1.5em;
  }
`;

const StyledSpan = styled.span`
  font-size: 1.2rem;
  color: ${COLORS.Grey};
  line-height: 25px;
`;

const ButtonContainer = styled.div`
  display: flex;
  column-gap: 20px;
  align-items: center;
`;
